import React, { Fragment } from 'react'
import styles from './index.css'

const SkeletonCard = () => (
  <div className="card">
    <div className="skeleton card-line-small" />
    <div className="skeleton card-line-long" />
    <div className="card-footer">
      <div className="skeleton card-footer-left" />
      <div className="skeleton card-footer-right" />
    </div>
  </div>
)

const SkeletonBullet = () => (
  <div className="bottom-line-wrapper">
    <div className="skeleton circle" />
    <div className="skeleton bottom-line" />
  </div>
)

export const SkeletonLoader = () => (
  <Fragment>
    <style>{styles}</style>
    <div className="host">
      <div className="scroll-wrapper">
        <div className="header">
          <div className="skeleton close-icon" />
        </div>

        <div className="top-section">
          <div className="skeleton box" />
          <div className="skeleton title line-1" />
          <div className="skeleton title line-2" />
          <div className="skeleton line line-3" />
          <div className="skeleton line line-4" />
        </div>

        <div className="input-box">
          <div className="skeleton input-label" />
          <div className="skeleton input-value" />
        </div>

        <div className="skeleton separator" />

        {[...Array(3)].map((_, i) => (
          <SkeletonCard key={i} />
        ))}

        <div className="skeleton bullets-title" />

        <div className="bottom-section">
          {[...Array(3)].map((_, i) => (
            <SkeletonBullet key={i} />
          ))}
        </div>
      </div>

      <div className="footer-bar">
        <div className="skeleton button" />
      </div>
    </div>
  </Fragment>
)